/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect } from "react";
import ColorPicker from "../ColorPicker.vue";
import { useDtfStore } from "../store";
import { cn } from "tailwind-variants";
import "./Preview.scss";

export default function Preview({ ...restProps }) {
  const colors = [
    "#000000",
    "#FFFFF0",
    "#4169E1",
    "#DC143C",
    "#228B22",
    "#671EA1",
    "#708090",
    "#FFD700",
    "#191970",
    "#800020"
  ];

  const store = useDtfStore();
  const [touched, setTouched] = useState(false);
  const [selection, setSelection] = useState(undefined);

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function currentColor() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return letterNumberArtwork().color || "#FFFFFF";
  }

  function previewStyle() {
    return cn(
      "jersey-numbers-preview__numbers",
      `jersey-numbers-preview__numbers--${
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        letterNumberArtwork().style
      }`
    );
  }

  function handleSelect(color: any) {
    setTouched(true);
    setSelection(color);
  }

  useEffect(() => {
    if (!touched) {
      // @ts-expect-error TS(2345): Argument of type '"#000000" | "#FFFFF0"' is not as... Remove this comment to see the full error message
      setSelection(currentColor() === "#FFFFFF" ? "#000000" : "#FFFFF0");
    }
  }, [touched]);

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("jersey-numbers-preview", restProps.className)}>
      <div
        className="jersey-numbers-preview__box"
        style={{
          backgroundColor: selection
        }}
      >
        <span
          className={previewStyle()}
          style={{
            color: currentColor()
          }}
        >
          <span>12345</span>
          <div className="jersey-numbers-preview__sep" />
          <span>67890</span>
        </span>
      </div>
      <p className="jersey-numbers-preview__label">Change Background Color</p>
      <ColorPicker
        value={selection}
        colors={colors}
        onChange={handleSelect}
        data-testid="color-picker"
      />
      <p className="jersey-numbers-preview__info-text">
        Preview Only: Background Color Won't Be Printed
      </p>
    </div>
  );
}
